import React from "react";
import HighlightsSection from "./HighlightsSection";
import AddEventComponent from "./AddEventComponent";

const CenterStageSection = () => {
  return (
    <>
      {/* <div className="w-full">
        <TimelineSection data={data} fetchTimeLineData={fetchTimeLineData} />
      </div> */}
      <div className="w-2/3">
        <AddEventComponent />
      </div>
      <div className="w-1/3">
        <HighlightsSection />
      </div>
    </>
  );
};

export default CenterStageSection;
